module.exports = __webpack_public_path__ + "static/img/xhLC.93776fcc.png";